import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button, Input } from 'reactstrap';
import PermissionTable from './PermissionTable'; // You can implement a similar table component for permissions
import { addPermission, getPermissions } from 'store/actions'; // Actions to add/get permissions
import CreatePermission from './CreatePermission'; // Component to create or edit permissions
import Breadcrumb from 'components/Common/Breadcrumb2';

const PermissionList = () => {
    const [isOpen, setIsOpen] = useState(false); // State to manage modal visibility
    const dispatch = useDispatch();
    const permissions = useSelector((state) => state.Permission.permissions); 
    const loading = useSelector((state) => state.Permission.loading); 
    const error = useSelector((state) => state.Permission.error);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));
 
    // Fetch permissions when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getPermissions()); // Dispatch action to fetch permissions
    }, [dispatch]);

    const handleSubmit = (data) => {
        dispatch(addPermission(data)); // Dispatch action to add a new permission
    };

    const handleClose = () => {
        setIsOpen(false); // Close modal when done
    };

    return (
        <>
            {/* Modal for creating/editing permissions */}
            <CreatePermission visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />
            <div className="page-content container-fluid">
                {/* Header section with title and button to add new permission */}
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb title="Permissions" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Permissions", link: '#' }]} />
                    {permissions2?.map(item=>item?.permissionName)?.includes("Add Permissions") && <Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => setIsOpen(true)}>
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>

                {/* Table to display list of permissions */}
                <PermissionTable List={permissions?.Data} loading={loading} error={error} />
            </div>
        </>
    );
};

export default PermissionList;
